import { AccessGuids, AlertClassColour, ConfigSystemParams, msSize, OurColors, TypeLicence } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ConfirmationModalFormComponent } from 'src/app/forms-modal/_pop-ups/confirmation-modal-form/confirmation-modal-form.component';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InputModalFormComponent } from 'src/app/forms-modal/_inputs/input-form/input-modal-form.component';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { licenceBillFromFirstOfNextMonth } from 'src/app/core/functions-generic/functions-generic-licence';
import { LicenceCompanyAllocatedDTO } from 'src/app/core/models/system/licence/licence-company-allocated.dto';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { LicencesCompanyVisibleSearchEmbeddedComponent } from 'src/app/pages-embedded/licences-company-visible-search/licences-company-visible-search.component';
import { LicencesCompanyVisibleService } from 'src/app/core/services/utelize/system/licence/licences-company-visible-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TypesLicenceService } from 'src/app/core/services/utelize/system/type/types-licence-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-licences-company-visible-modal-form-search',
  templateUrl: './licences-company-visible-modal-form-search.component.html',
  styleUrls: ['./licences-company-visible-modal-form-search.component.scss']
})

export class LicencesCompanyVisibleModalFormSearchComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @Input() allocateSelectedLicence: boolean | undefined;

  @Output() searchFormCancelled   : EventEmitter<boolean>=new EventEmitter<boolean>();
  @Output() searchFormHasBeenSaved: EventEmitter<void>   =new EventEmitter<void>   ();
  @Output() searchGridRowClick    : EventEmitter<number> =new EventEmitter<number> ();
  @Output() searchGridRowDblClick : EventEmitter<number> =new EventEmitter<number> ();

  @ViewChild('addLicenceConfirmationModal',      { static: false }) addLicenceConfirmationModal!: ConfirmationModalFormComponent;
  @ViewChild('completedModalForm',               { static: false }) completedModalForm!         : CompletedModalFormComponent;
  @ViewChild('inputModalForm',                   { static: false }) inputModalForm!             : InputModalFormComponent;
  @ViewChild('licencesCompanyVisibleFormSearch', { static: false }) searchFormModal!            : TemplateRef<void>;
  @ViewChild('licencesCompanyVisibleSearchGrid', { static: false }) searchGrid!                 : LicencesCompanyVisibleSearchEmbeddedComponent;
  @ViewChild('warningModalForm',                 { static: false }) warningModalForm!           : WarningModalFormComponent;
  
  get isLicencesAdminKeyHolder() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.LicencesAdminKey, true); }
    
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                          
  get allowOverrideStartDate    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesAllowOverrideStartDate,     false); }
  get multiplePlatformQuantity  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPlatformMultipleQuantity,   false); }
  get multiplePoolBundleQuantity() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPoolBundleMultipleQuantity, false); }
  get showSystemOwnedToUsers    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesShowSystemOwnedToUsers,     false); }
  get usageZoneOverlapCheck     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesUsageZoneOverlapCheck,      true ); }

  private confirmingOverrideStartDate : boolean=false;
  private initialStatus               : string="Select a licence to apply";
  private originalStartDate           : string | undefined;
  private pendingOverrideStartDate    : Date | undefined;
  private pendingQuantity             : number=1;
  private searchFormModalRef!         : NgbModalRef;
  private selectedLicenceAllowMany    : boolean=false;
  private selectedLicenceIsProcessing : boolean=false;
  private selectedLicencePlatformAddOn: boolean=false;
  private selectedLicenceSystemId     : number | undefined;
  private selectedLicenceType         : string | undefined;
  private selectedRowId               : number | undefined;
  private typeLicenceFirstFilterDone  : boolean=false;
   
  public alertColourProgress    : string=AlertClassColour.Green;
  public companyId              : number | undefined;
  public curUser                : SystemUserDTO;
  public formSubmitted          : boolean=false;
  public formTitle              : string="Licence Selection";
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public searchForm!            : UntypedFormGroup;
  public submitButtonEnabled    : boolean=false;
  public typeLicenceDropDownDesc: string | undefined=TypeLicence.Unknown;
  public typeLicenceDropDownId  : number=0;

  constructor(
    private authenticationService          : AuthenticationService,
    private componentAccessUserService     : ComponentAccessUserService,
    private configSystemService            : ConfigSystemService,
    private exceptionsService              : ExceptionsService,
    private formBuilder                    : UntypedFormBuilder,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private licencesCompanyVisibleService  : LicencesCompanyVisibleService,
    private modalService                   : NgbModal,
    private typesLicenceService            : TypesLicenceService
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.alertColourProgress           =AlertClassColour.Green;
      this.confirmingOverrideStartDate   =false;
      this.formSubmitted                 =false;
      this.originalStartDate             =undefined;
      this.pendingOverrideStartDate      =undefined;
      this.pendingQuantity               =1;
      this.progressInformation           =this.initialStatus;
      this.selectedLicenceAllowMany      =false;
      this.selectedLicenceIsProcessing   =false;
      this.selectedLicencePlatformAddOn  =false;
      this.selectedLicenceSystemId       =undefined;
      this.selectedLicenceType           =undefined;
      this.selectedRowId                 =undefined;
      this.submitButtonEnabled           =false;
      this.typeLicenceDropDownDesc       =TypeLicence.Unknown;
      this.typeLicenceDropDownId         =0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(companyId: number | undefined): void {
    try {
      this.companyId=companyId;

      this.resetMainVariables();
      this.setUpForm();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.searchFormModalRef=this.modalService.open(this.searchFormModal, { backdrop: this.modalBackGround,
                                                                             centered: true,
                                                                             keyboard: false,
                                                                             size    : msSize.ExtraLarge });
    }
    catch(e) {
      this.searchFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private formatNaiveDateAsDDMMYYYY(value: string | Date): string {
    try {
      if (!value)
        return "";

      const str : string=typeof value==="string"
                         ? value
                         : value.getFullYear()+"-"+
                           String(value.getMonth()+1).padStart(2, "0")+"-"+
                           String(value.getDate ()  ).padStart(2, "0");
      const yyyy: string=str.substring(0, 4);
      const mm  : string=str.substring(5, 7);
      const dd  : string=str.substring(8, 10);

      return dd + "/" + mm + "/" + yyyy;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  //#region searchForm
  
  get formOfSearch() {
    return this.searchForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.searchForm);

       this.searchForm=this.formBuilder.group({ });
      
      this.addFormFields(this.searchForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        // this.addFormControl(formGroup, "exampleOfAField", false, []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.searchForm) {
        
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public typeLicenceDropDownOnChange(licenceType: IdAndDescriptionDTO | undefined) {
    try {
      this.typeLicenceDropDownId  =licenceType==undefined || licenceType.id==undefined ? 0 : <number>licenceType.id;
      this.typeLicenceDropDownDesc=licenceType?.description ?? TypeLicence.Unknown;

      if (this.typeLicenceFirstFilterDone)
        this.searchGrid.refilter();
      else
        this.typeLicenceFirstFilterDone=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.searchForm.valid && !this.selectedLicenceIsProcessing) {
        if (this.selectedRowId) {
          this.selectedLicenceIsProcessing=true;
          
          if (this.allocateSelectedLicence) {
            this.allocateLicence()

          } else {
            this.searchGridRowClick.emit(this.selectedRowId);
            this.searchFormHasBeenSaved.emit();
            this.searchFormModalRef.close();
          }

        } else {
          this.warningModalForm.openForm("Select a Licence", "...or simply close the form", "https://cdn.lordicon.com/sjoccsdj.json");
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public searchFormCancel() {
    try {
      this.searchFormCancelled.emit();
      this.searchFormModalRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowClick(rowId: number) {
    try {
      this.selectedRowId=rowId;
      
      this.searchGridRowClick.emit(this.selectedRowId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridRowDblClick(rowId: number) {
    try {
      if (!this.selectedLicenceIsProcessing) {
        this.selectedRowId=rowId;
        
        if (this.searchForm.valid) {
          this.selectedLicenceIsProcessing=true;
          
          if (this.allocateSelectedLicence) {
            this.allocateLicence();
          
          } else {
            this.searchGridRowDblClick.emit(this.selectedRowId);
            this.searchFormModalRef.close();
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public allocateLicence() {
    try {
      this.getLicenceIdFromSelectedRow();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getLicenceIdFromSelectedRow() {
    try {
      this.licencesCompanyVisibleService.getById(<number>this.selectedRowId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (isNaN(data.licenceSystemID)) {
            this.exceptionsService.handleException(new Error("LicencesCompanyVisibleModalFormSearchComponent.getLicenceIdFromSelectedRow()..licenceSystemID cannot be determined"));

          } else if (!data.licenceType || (data.licenceType != TypeLicence.Bundle     &&
                                           data.licenceType != TypeLicence.Feature    &&
                                           data.licenceType != TypeLicence.Platform   &&
                                           data.licenceType != TypeLicence.PoolBundle &&
                                           data.licenceType != TypeLicence.Usage)) {
            this.exceptionsService.handleException(new Error("LicencesCompanyVisibleModalFormSearchComponent.getLicenceIdFromSelectedRow()..licenceType cannot be determined"));

          } else if (data.adminLocked && !this.isLicencesAdminKeyHolder) {
            this.selectedLicenceIsProcessing=false;
            this.warningModalForm.openForm("Admin Locked Licence", "Admin Locked Licences cannot be allocated by you");

          } else {
            this.selectedLicenceAllowMany      =data.licenceAllowMany ?? false;
            this.selectedLicencePlatformAddOn  =data.licencePlatformAddOn ?? false;
            this.selectedLicenceSystemId       =data.licenceSystemID;
            this.selectedLicenceType           =data.licenceType;
            this.checkIfAlreadyHaveLicence();
          }
        },
        error: error => {
          this.selectedLicenceIsProcessing=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public checkIfAlreadyHaveLicence() {
    try {
      if (this.selectedLicenceType==TypeLicence.Bundle     ||
          this.selectedLicenceType==TypeLicence.PoolBundle ||
          this.selectedLicenceType==TypeLicence.Platform   ||
          this.selectedLicenceType==TypeLicence.Feature && this.selectedLicenceAllowMany) {
        this.calculateStartDateForNewLicence();

      } else {
        const dataSource=this.selectedLicenceType==TypeLicence.Feature ? this.licencesCompanyAllocatedService.companyHasLicenceFeature(<number>this.companyId, <number>this.selectedLicenceSystemId)
                                                                       : (this.selectedLicenceType==TypeLicence.Usage ? this.licencesCompanyAllocatedService.companyHasLicenceUsage(<number>this.companyId, <number>this.selectedLicenceSystemId)
                                                                                                                      : undefined
                                                                         );

        if (dataSource) {
          dataSource
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              if (data.result) {
                this.selectedLicenceIsProcessing=false;
                this.warningModalForm.openForm("Company already has Licence", "No need to select this licence");
              }
              else if (this.selectedLicenceType==TypeLicence.Usage && this.usageZoneOverlapCheck)
                this.checkUsageZoneOverlap();
              else
                this.calculateStartDateForNewLicence();
            },
            error: error => {
              this.selectedLicenceIsProcessing=false;
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public checkUsageZoneOverlap() {
    try {
      this.licencesCompanyAllocatedService.companyHasLicenceUsageZoneOverlap(<number>this.companyId, <number>this.selectedLicenceSystemId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (data.result) {
            this.selectedLicenceIsProcessing=false;
            this.warningModalForm.openForm("Zone conflict with existing Rate licence",
                                           "Cannot add - these zones are already covered by an active Rate licence: " +
                                           (data.stringArrayResult ?? []).join(", "));
          }
          else
            this.calculateStartDateForNewLicence();
        },
        error: error => {
          this.selectedLicenceIsProcessing=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public calculateStartDateForNewLicence() {
    try {
      this.typesLicenceService.calculateStartDateForNewLicence(<string>this.selectedLicenceType)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!data || !data.result) {
            this.selectedLicenceIsProcessing=false;
            this.exceptionsService.handleException(new Error("LicencesCompanyVisibleModalFormSearchComponent - Licence Start Date cannot be calculated"));
          
          } else {
            this.originalStartDate=data.result;
            this.calculateCancellationDateForNewLicence(data.result);
          }
        },
        error: error => {
          this.selectedLicenceIsProcessing=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public calculateCancellationDateForNewLicence(startDate: string) {
    try {
      this.typesLicenceService.calculateCancellationDateForNewLicence(<string>this.selectedLicenceType)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!data || !data.result) {
            this.selectedLicenceIsProcessing=false;
            this.exceptionsService.handleException(new Error("LicencesCompanyVisibleModalFormSearchComponent - Licence End Date cannot be calculated"));
          
          } else {
            const billFromFirstOfNextMonth: boolean=licenceBillFromFirstOfNextMonth(this.configSystemService, this.exceptionsService, <string>this.selectedLicenceType);
            const endDate                 : string =data.result;

            let messagePostfix: string=billFromFirstOfNextMonth
                                      ? "Will bill from the start of next month"
                                      : "Will bill immediately";
            
            const startDateFormatted: string=this.formatNaiveDateAsDDMMYYYY(startDate);
            const endDateFormatted  : string=this.formatNaiveDateAsDDMMYYYY(endDate);

            messagePostfix += ("<br><strong>" + startDateFormatted + "</strong><br><br>");

            messagePostfix += billFromFirstOfNextMonth
                              ? "Can be cancelled up until<br>start without charge"
                              : "If cancelled today<br>charges will occur up to " +
                                "<br><strong>" + endDateFormatted + "</strong><br>";

            this.addLicenceConfirmationModal.openForm("WARNING - LICENCE BILLING",
                                                      "<strong>Add Licence, are you sure?</strong>" +
                                                      "<br>" +
                                                      "<br>" +
                                                      messagePostfix,
                                                      undefined,
                                                      OurColors.Red,
                                                      OurColors.DarkBlue);
          }
        },
        error: error => {
          this.selectedLicenceIsProcessing=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public noAddLicence() {
    try {
      this.confirmingOverrideStartDate=false;
      this.selectedLicenceIsProcessing=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesAddLicence() {
    try {
      if (this.confirmingOverrideStartDate) {
        this.confirmingOverrideStartDate=false;
        this.createLicenceCompanyAllocatedRecord(this.pendingQuantity, this.pendingOverrideStartDate);
      }
      else {
        this.selectQuantity();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public selectQuantity() {
    try {
      const quantityRequired: boolean=this.selectedLicenceType==TypeLicence.Bundle ||
                                      (this.multiplePoolBundleQuantity && this.selectedLicenceType==TypeLicence.PoolBundle) ||
                                      (this.multiplePlatformQuantity && this.selectedLicenceType==TypeLicence.Platform && this.selectedLicencePlatformAddOn);

      if (quantityRequired || this.allowOverrideStartDate) {
        this.inputModalForm.date0Caption="Start Date";
        this.inputModalForm.date0Show   =this.allowOverrideStartDate;
        this.inputModalForm.formTitle   =this.allowOverrideStartDate && !quantityRequired ? "Licence Start Date" : "Number of Items";
        this.inputModalForm.fieldCaption="Quantity";
        this.inputModalForm.input0Show  =quantityRequired;
        this.inputModalForm.openForm();

      } else {
        this.createLicenceCompanyAllocatedRecord(1, undefined);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inputModalFormSubmitted(inputValue: string) {
    try {
      const _inputValue=Number(inputValue);

      if (isNaN(_inputValue)) {
        this.selectedLicenceIsProcessing=false;
        throw new Error("The quantity submitted is not a valid number.");
      }

      this.createLicenceCompanyAllocatedRecord(_inputValue, undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inputModalFormSubmittedExt(values: { input0: string | undefined, date0: string | undefined }) {
    try {
      let quantity: number=1;

      if (values.input0 != undefined) {
        const parsed: number=Number(values.input0);

        if (isNaN(parsed)) {
          this.selectedLicenceIsProcessing=false;
          throw new Error("LicencesCompanyVisibleModalFormSearchComponent.inputModalFormSubmittedExt() - The quantity submitted is not a valid number.");
        }

        quantity=parsed;
      }

      const chosenStartDate: Date | undefined=values.date0 ? new Date(values.date0) : undefined;

      // const dateChanged: boolean=chosenStartDate != undefined && this.startDatesDiffer(chosenStartDate, this.originalStartDate);
      //
      // if (dateChanged) {
      //   this.pendingQuantity         =quantity;
      //   this.pendingOverrideStartDate=chosenStartDate;
      //   this.confirmOverrideStartDate(<Date>chosenStartDate);
      // }
      // else {
      //   this.createLicenceCompanyAllocatedRecord(quantity, undefined);
      // }

      this.createLicenceCompanyAllocatedRecord(quantity, chosenStartDate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private startDatesDiffer(a: Date, b: string | undefined): boolean {
    try {
      if (!b)
        return true;

      const ad: Date=new Date(a); ad.setHours(0, 0, 0, 0);
      const bd: Date=new Date(b); bd.setHours(0, 0, 0, 0);

      return ad.getTime() != bd.getTime();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private addOneMonthMinusOneDay(date: Date): Date {
    try {
      const result: Date=new Date(date);

      result.setMonth(result.getMonth() + 1);
      result.setDate(result.getDate() - 1);

      return result;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return date;
    }
  }

  private confirmOverrideStartDate(startDate: Date): void {
    try {
      const endDate: Date=this.addOneMonthMinusOneDay(startDate);

      const startDateFormatted: string=this.formatNaiveDateAsDDMMYYYY(startDate);
      const endDateFormatted  : string=this.formatNaiveDateAsDDMMYYYY(endDate);

      const messagePostfix: string="Will bill from" +
                                   "<br><strong>" + startDateFormatted + "</strong><br><br>" +
                                   "If cancelled today<br>charges will occur up to " +
                                   "<br><strong>" + endDateFormatted + "</strong><br>";

      this.confirmingOverrideStartDate=true;

      this.addLicenceConfirmationModal.openForm("WARNING - LICENCE BILLING",
                                                "<strong>Add Licence, are you sure?</strong>" +
                                                "<br>" +
                                                "<br>" +
                                                messagePostfix,
                                                undefined,
                                                OurColors.Red,
                                                OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public createLicenceCompanyAllocatedRecord(quantity: number, startDate: Date | undefined) {
    try {
      const licenceCompanyAllocated: LicenceCompanyAllocatedDTO={
        active         : true,
        companyID      : <number>this.companyId,
        enteredBy      : this.curUser.userId,
        id             : -1,
        licenceSystemID: <number>this.selectedLicenceSystemId,
        quantity       : quantity,
        startDate      : startDate
      }
      
      this.licencesCompanyAllocatedService.post(licenceCompanyAllocated)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.searchGridRowClick.emit(this.selectedRowId);
          this.searchFormHasBeenSaved.emit();
          this.searchFormModalRef.close();
        },
        error: error => {
          this.selectedLicenceIsProcessing=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
}
